/**
 * PHILADELPHIA MARKET DATA
 * Static market rental data by zip code and bedroom count
 * Data based on recent rental market analysis
 * 15 supported zip codes matching HUD FMR data
 */

const philadelphiaMarketData = {
  // Center City
  '19103': {
    neighborhood: 'Rittenhouse',
    medianRents: {
      0: { medianRent: 1600, lowRange: 1400, highRange: 1900, sampleSize: 35 },
      1: { medianRent: 1900, lowRange: 1650, highRange: 2250, sampleSize: 60 },
      2: { medianRent: 2500, lowRange: 2150, highRange: 3000, sampleSize: 55 },
      3: { medianRent: 3200, lowRange: 2750, highRange: 3800, sampleSize: 28 },
      4: { medianRent: 4000, lowRange: 3400, highRange: 4800, sampleSize: 12 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  '19106': {
    neighborhood: 'Old City',
    medianRents: {
      0: { medianRent: 1550, lowRange: 1350, highRange: 1850, sampleSize: 30 },
      1: { medianRent: 1850, lowRange: 1600, highRange: 2200, sampleSize: 55 },
      2: { medianRent: 2450, lowRange: 2100, highRange: 2900, sampleSize: 50 },
      3: { medianRent: 3100, lowRange: 2650, highRange: 3700, sampleSize: 25 },
      4: { medianRent: 3850, lowRange: 3300, highRange: 4600, sampleSize: 10 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  '19107': {
    neighborhood: 'Washington Square',
    medianRents: {
      0: { medianRent: 1500, lowRange: 1300, highRange: 1800, sampleSize: 28 },
      1: { medianRent: 1800, lowRange: 1550, highRange: 2150, sampleSize: 52 },
      2: { medianRent: 2400, lowRange: 2050, highRange: 2850, sampleSize: 48 },
      3: { medianRent: 3000, lowRange: 2550, highRange: 3600, sampleSize: 22 },
      4: { medianRent: 3700, lowRange: 3150, highRange: 4400, sampleSize: 8 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  // University City
  '19104': {
    neighborhood: 'University City',
    medianRents: {
      0: { medianRent: 1300, lowRange: 1100, highRange: 1500, sampleSize: 25 },
      1: { medianRent: 1500, lowRange: 1300, highRange: 1750, sampleSize: 50 },
      2: { medianRent: 1900, lowRange: 1650, highRange: 2250, sampleSize: 55 },
      3: { medianRent: 2400, lowRange: 2050, highRange: 2850, sampleSize: 35 },
      4: { medianRent: 2900, lowRange: 2500, highRange: 3500, sampleSize: 18 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  // Northwest Philadelphia
  '19119': {
    neighborhood: 'West Mount Airy',
    medianRents: {
      0: { medianRent: 1100, lowRange: 950, highRange: 1300, sampleSize: 15 },
      1: { medianRent: 1300, lowRange: 1100, highRange: 1500, sampleSize: 32 },
      2: { medianRent: 1600, lowRange: 1400, highRange: 1900, sampleSize: 38 },
      3: { medianRent: 1950, lowRange: 1700, highRange: 2300, sampleSize: 28 },
      4: { medianRent: 2300, lowRange: 2000, highRange: 2700, sampleSize: 12 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  '19144': {
    neighborhood: 'Germantown',
    medianRents: {
      0: { medianRent: 1050, lowRange: 900, highRange: 1250, sampleSize: 18 },
      1: { medianRent: 1250, lowRange: 1050, highRange: 1450, sampleSize: 35 },
      2: { medianRent: 1550, lowRange: 1350, highRange: 1800, sampleSize: 42 },
      3: { medianRent: 1900, lowRange: 1650, highRange: 2200, sampleSize: 30 },
      4: { medianRent: 2200, lowRange: 1900, highRange: 2600, sampleSize: 14 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  '19150': {
    neighborhood: 'East Mount Airy',
    medianRents: {
      0: { medianRent: 1100, lowRange: 950, highRange: 1300, sampleSize: 14 },
      1: { medianRent: 1300, lowRange: 1100, highRange: 1500, sampleSize: 30 },
      2: { medianRent: 1600, lowRange: 1400, highRange: 1900, sampleSize: 36 },
      3: { medianRent: 1950, lowRange: 1700, highRange: 2300, sampleSize: 25 },
      4: { medianRent: 2300, lowRange: 2000, highRange: 2700, sampleSize: 10 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  // North Philadelphia
  '19121': {
    neighborhood: 'Brewerytown',
    medianRents: {
      0: { medianRent: 1100, lowRange: 950, highRange: 1300, sampleSize: 18 },
      1: { medianRent: 1300, lowRange: 1100, highRange: 1500, sampleSize: 35 },
      2: { medianRent: 1650, lowRange: 1400, highRange: 1900, sampleSize: 42 },
      3: { medianRent: 2000, lowRange: 1750, highRange: 2400, sampleSize: 28 },
      4: { medianRent: 2350, lowRange: 2000, highRange: 2800, sampleSize: 10 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  // Fishtown / Northern Liberties
  '19123': {
    neighborhood: 'Northern Liberties',
    medianRents: {
      0: { medianRent: 1400, lowRange: 1200, highRange: 1600, sampleSize: 22 },
      1: { medianRent: 1600, lowRange: 1400, highRange: 1900, sampleSize: 48 },
      2: { medianRent: 2050, lowRange: 1800, highRange: 2400, sampleSize: 55 },
      3: { medianRent: 2550, lowRange: 2200, highRange: 3000, sampleSize: 32 },
      4: { medianRent: 3000, lowRange: 2600, highRange: 3600, sampleSize: 12 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  '19125': {
    neighborhood: 'Fishtown',
    medianRents: {
      0: { medianRent: 1350, lowRange: 1150, highRange: 1550, sampleSize: 28 },
      1: { medianRent: 1550, lowRange: 1350, highRange: 1800, sampleSize: 45 },
      2: { medianRent: 1950, lowRange: 1700, highRange: 2300, sampleSize: 52 },
      3: { medianRent: 2400, lowRange: 2100, highRange: 2900, sampleSize: 38 },
      4: { medianRent: 2800, lowRange: 2400, highRange: 3400, sampleSize: 15 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  // Fairmount / Art Museum
  '19130': {
    neighborhood: 'Fairmount',
    medianRents: {
      0: { medianRent: 1250, lowRange: 1050, highRange: 1450, sampleSize: 18 },
      1: { medianRent: 1450, lowRange: 1250, highRange: 1700, sampleSize: 40 },
      2: { medianRent: 1800, lowRange: 1550, highRange: 2100, sampleSize: 45 },
      3: { medianRent: 2200, lowRange: 1900, highRange: 2600, sampleSize: 28 },
      4: { medianRent: 2600, lowRange: 2250, highRange: 3100, sampleSize: 11 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  // West Philadelphia
  '19131': {
    neighborhood: 'Overbrook',
    medianRents: {
      0: { medianRent: 950, lowRange: 800, highRange: 1100, sampleSize: 10 },
      1: { medianRent: 1150, lowRange: 950, highRange: 1350, sampleSize: 28 },
      2: { medianRent: 1400, lowRange: 1200, highRange: 1650, sampleSize: 35 },
      3: { medianRent: 1700, lowRange: 1450, highRange: 2000, sampleSize: 30 },
      4: { medianRent: 2000, lowRange: 1700, highRange: 2400, sampleSize: 12 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  '19151': {
    neighborhood: 'Overbrook Park',
    medianRents: {
      0: { medianRent: 900, lowRange: 750, highRange: 1050, sampleSize: 8 },
      1: { medianRent: 1100, lowRange: 900, highRange: 1300, sampleSize: 22 },
      2: { medianRent: 1350, lowRange: 1150, highRange: 1600, sampleSize: 30 },
      3: { medianRent: 1650, lowRange: 1400, highRange: 1950, sampleSize: 25 },
      4: { medianRent: 1950, lowRange: 1650, highRange: 2300, sampleSize: 10 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  // South Philadelphia
  '19146': {
    neighborhood: 'Graduate Hospital',
    medianRents: {
      0: { medianRent: 1300, lowRange: 1100, highRange: 1500, sampleSize: 20 },
      1: { medianRent: 1500, lowRange: 1300, highRange: 1750, sampleSize: 42 },
      2: { medianRent: 1900, lowRange: 1650, highRange: 2200, sampleSize: 50 },
      3: { medianRent: 2350, lowRange: 2000, highRange: 2750, sampleSize: 30 },
      4: { medianRent: 2750, lowRange: 2400, highRange: 3200, sampleSize: 14 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  },

  '19148': {
    neighborhood: 'Passyunk',
    medianRents: {
      0: { medianRent: 1150, lowRange: 1000, highRange: 1350, sampleSize: 18 },
      1: { medianRent: 1350, lowRange: 1150, highRange: 1600, sampleSize: 40 },
      2: { medianRent: 1700, lowRange: 1450, highRange: 2000, sampleSize: 48 },
      3: { medianRent: 2100, lowRange: 1800, highRange: 2500, sampleSize: 32 },
      4: { medianRent: 2500, lowRange: 2150, highRange: 3000, sampleSize: 12 }
    },
    lastUpdated: '2024-01-15',
    dataSource: 'Local MLS + Rentcast aggregation'
  }
};

/**
 * Get market data for a specific zip code and bedroom count
 * @param {string} zipCode - 5-digit zip code
 * @param {number} bedrooms - Number of bedrooms (0 for studio)
 * @returns {Object|null} Market data object or null if not found
 */
export function getMarketData(zipCode, bedrooms) {
  const zipData = philadelphiaMarketData[zipCode];

  if (!zipData) {
    console.warn(`No market data found for zip code: ${zipCode}`);
    return null;
  }

  const bedroomData = zipData.medianRents[bedrooms];

  if (!bedroomData) {
    console.warn(`No market data for ${bedrooms}BR in ${zipCode}`);
    return null;
  }

  return {
    ...bedroomData,
    neighborhood: zipData.neighborhood,
    lastUpdated: zipData.lastUpdated,
    dataSource: zipData.dataSource
  };
}

/**
 * Get list of supported zip codes with neighborhood names
 * @returns {Array} Array of { zipCode, neighborhood } objects
 */
export function getSupportedZipCodes() {
  return Object.entries(philadelphiaMarketData).map(([zipCode, data]) => ({
    zipCode,
    neighborhood: data.neighborhood
  }));
}

/**
 * Check if a zip code is supported
 * @param {string} zipCode - 5-digit zip code
 * @returns {boolean}
 */
export function isZipCodeSupported(zipCode) {
  return zipCode in philadelphiaMarketData;
}

/**
 * Get full data for a zip code (all bedroom types)
 * @param {string} zipCode - 5-digit zip code
 * @returns {Object|null}
 */
export function getZipCodeData(zipCode) {
  return philadelphiaMarketData[zipCode] || null;
}

export default philadelphiaMarketData;
